import { Link } from "react-router-dom";
import type { ContentItem } from "@/mocks/content";
import ContentCard from "@/components/base/ContentCard";

interface RelatedPanelProps {
  related: ContentItem[];
}

export default function RelatedPanel({ related }: RelatedPanelProps) {
  if (related.length === 0) return null;

  return (
    <aside className="lg:w-80 shrink-0">
      <div className="lg:sticky lg:top-24">
        <h3 className="text-base font-heading font-semibold text-foreground-950 mb-4">
          相关推荐
        </h3>
        <div className="flex lg:flex-col gap-4 overflow-x-auto lg:overflow-visible pb-2 lg:pb-0 -mx-1 px-1 lg:mx-0 lg:px-0">
          {related.map((item) => (
            <div key={item.id} className="min-w-[220px] lg:min-w-0">
              <ContentCard item={item} variant="compact" />
            </div>
          ))}
        </div>
        <Link
          to="/contact"
          className="mt-6 hidden lg:flex items-center justify-between gap-2 bg-background-100 border border-background-200 rounded-lg p-4 hover:border-primary-300 transition-colors cursor-pointer"
        >
          <span className="text-sm text-foreground-700">想了解更多？联系我们</span>
          <i className="ri-arrow-right-line text-primary-600"></i>
        </Link>
      </div>
    </aside>
  );
}